import {
  Datagrid,
  DateField,
  ListProps,
  TextField,
  UrlField
} from 'react-admin';
import { CustomList, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function OffersList(props: ListProps) {
  return (
    <CustomList
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid body={<SortableDatagridBody />} rowClick="edit">
        <TextField label="Título" source="title" sortable={false} />

        <UrlField label="Link" source="link" sortable={false} />

        <DateField
          locales="pt-BR" 
          options={{ timeZone: 'UTC' }}
          label="Inicia em"
          source="startsAt"
          sortable={false}
        />

        <DateField
          locales="pt-BR" 
          options={{ timeZone: 'UTC' }}
          label="Finaliza em"
          source="endsAt"
          sortable={false}
        />

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
